var render, staticRenderFns
import script from "./formatterModulosRRHH.vue?vue&type=script&lang=js&"
export * from "./formatterModulosRRHH.vue?vue&type=script&lang=js&"
import style0 from "./formatterModulosRRHH.vue?vue&type=style&index=0&id=353845ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353845ee",
  null
  
)

export default component.exports